var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBranch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#292D32",
  d: "m12.37 2.9 9 3.6a1.08 1.08 0 0 1 .63.93v3.32a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.43a1.08 1.08 0 0 1 .63-.93l9-3.6c.24-.08.5-.08.74 0ZM22 22.75H2v-3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zM4 18.75v-7M8 18.75v-7M12 18.75v-7M16 18.75v-7M20 18.75v-7M1 22.75h22"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#292D32",
  d: "M13.5 7.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
})));
export { SvgBranch as ReactComponent };
export default __webpack_public_path__ + "6977592f29dfcd4b2de411fbbafe2896.svg";